import "../style.css"

// Our modules / classes
import NavToggler from "./modules/NavToggler"


// Instantiate a new object using our modules/classes

const navToggler = new NavToggler()





